import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { UserService } from 'src/app/services/user-service/user.service';
import { Subscription } from 'rxjs';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { User } from 'src/app/models/user-model/user.model';

@Component({
  selector: 'app-users-users-dashboard',
  templateUrl: './users-users-dashboard.component.html',
  styleUrls: ['./users-users-dashboard.component.scss']
})
export class UsersUsersDashboardComponent implements OnInit, OnDestroy {

  users;
  filterKey;
  noItemsConfig;
  viewDisposition = 'grid';
  getUsersSubscription: Subscription;
  getUsersSubscriptionRefresh: Subscription;
  searchUsersSubscription: Subscription;
  toggleUserDispositionSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private userService: UserService,
              private userStorageService: UserStorageService,
              private snackbarService: SnackBarService) {
                this.noItemsConfig = this.setNoItemsConfig();
              }

  ngOnInit() {
    this.setBreadcrumb();
    this.getUsers();
    this.getUsersSubscriptionRefresh = this.userService.refreshUsersListen().subscribe(
      (res) => {
        this.getUsers();
      }
    );
    this.searchUsersSubscription = this.userService.searchUsersListen().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
    this.toggleUserDispositionSubscription = this.userService.toggleUserDispositionListen().subscribe(
      (res) => {
        this.viewDisposition = res;
      }
    );
  }

  private getUsers() {
    this.getUsersSubscription = this.userService.getUsers().subscribe(
      (res) => {
        this.users = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-users', 'users-page.users', '/account', [new BRoute('account-page.account', '/account'), new BRoute('users-page.users')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'users-page.users not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngOnDestroy() {
    if (this.getUsersSubscription) { this.getUsersSubscription.unsubscribe(); }
    if (this.getUsersSubscriptionRefresh) { this.getUsersSubscriptionRefresh.unsubscribe(); }
    if (this.searchUsersSubscription) { this.searchUsersSubscription.unsubscribe(); }
    if (this.toggleUserDispositionSubscription) { this.toggleUserDispositionSubscription.unsubscribe(); }
  }

}
